import type { NewsItem } from '@/types';

export const newsList: NewsItem[] = [
  {
    id: 'news-001',
    title: '《星海旅人》第二季正式定档，全新 PV 公开',
    date: '2026-10-10',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20space%20traveler%20girl%20before%20a%20giant%20purple%20nebula%2C%20dramatic%20lighting%2C%20news%20banner%20illustration&width=800&height=450&seq=news-cover-01&orientation=landscape',
    summary: '备受期待的《星海旅人》第二季宣布将于明年一月开播，官方同步放出全新剧情 PV 与主视觉图。',
    content: [
      { type: 'paragraph', text: '在昨晚举行的线上发布会中，制作方正式公布了《星海旅人》第二季的定档信息。新一季将于明年一月正式开播，全季共十二集，并保留第一季的核心制作团队。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20space%20traveler%20girl%20and%20her%20crew%20on%20the%20bridge%20of%20a%20starship%2C%20warm%20rim%20light%2C%20detailed%20illustration&width=800&height=450&seq=news-inline-01&orientation=landscape', caption: '第二季主视觉图（官方公开画面）' },
      { type: 'heading', text: '剧情走向：更深的星海，更难的抉择' },
      { type: 'paragraph', text: '据导演透露，第二季的重心将从「寻找母星」转向「如何定义家园」。诺雅与伙伴们将面对更大的星际势力博弈，此前的许多伏笔也会在本季中得到解答。' },
      { type: 'paragraph', text: '官方同时开启了限定周边预约，首批预约将在开播前一周截止。该消息一经公布，相关话题迅速登上多个动漫社区的热门榜单。' },
    ],
    tags: ['星海旅人', '新番', '定档'],
    category: '新番动态',
  },
  {
    id: 'news-002',
    title: '国产动画《剑影长歌》播放量突破十亿',
    date: '2026-10-08',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20swordsman%20with%20a%20glowing%20blade%20amid%20falling%20embers%2C%20epic%20sunset%20background%2C%20news%20banner%20illustration&width=800&height=450&seq=news-cover-02&orientation=landscape',
    summary: '上线仅三个月，《剑影长歌》全平台累计播放量正式突破十亿，成为今年表现最亮眼的国产动画之一。',
    content: [
      { type: 'paragraph', text: '《剑影长歌》自开播以来热度持续攀升，凭借扎实的打斗作画与紧凑的剧情叙事，收获了大量观众的认可。官方今日宣布，其全平台累计播放量已正式突破十亿大关。' },
      { type: 'heading', text: '口碑与热度双丰收' },
      { type: 'paragraph', text: '除了播放数据亮眼，该作品在各大评分社区的评分同样稳居前列。不少观众表示，作品对江湖义气的刻画，以及主角云长歌的成长弧线，是吸引他们持续追更的关键。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20two%20swordsmen%20clashing%20with%20sparks%20on%20a%20mountain%20cliff%20at%20sunset%2C%20dynamic%20action%2C%20detailed%20illustration&width=800&height=450&seq=news-inline-02&orientation=landscape', caption: '剧中经典对决场面（官方公开画面）' },
      { type: 'paragraph', text: '制作组表示，后续剧情将进入新的篇章，主角一行将迎来更强大的对手，感谢观众一路以来的支持。' },
    ],
    tags: ['剑影长歌', '国产动画', '播放量'],
    category: '行业动态',
  },
  {
    id: 'news-003',
    title: '2027 春季新番前瞻：值得期待的十部作品',
    date: '2026-10-06',
    author: '特约撰稿人 · 青岚',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20spring%20season%20preview%20collage%20of%20colorful%20heroines%20under%20cherry%20blossoms%2C%20bright%20cheerful%20illustration%2C%20news%20banner&width=800&height=450&seq=news-cover-03&orientation=landscape',
    summary: '新一季新番阵容公布，续作与原创齐飞。我们整理了十部最值得关注的作品，帮你提前规划追番清单。',
    content: [
      { type: 'paragraph', text: '随着新一季动画档期名单陆续公布，春季新番的整体阵容已经初现轮廓。这一季既有备受期待的续作，也有不少制作精良的原创作品。' },
      { type: 'heading', text: '续作阵营：稳定发挥的安心选择' },
      { type: 'paragraph', text: '多部人气作品的续作确认定档，其中包括《星轨编年史》的外传企划，以及《逆风跑者》第二季。对于追更党来说，这一季不用担心没得看。' },
      { type: 'heading', text: '原创黑马：值得押注的新面孔' },
      { type: 'paragraph', text: '除了续作，几部原创动画的预告片也展现出不俗的制作水准。尤其是主打悬疑氛围与都市题材的两部作品，被不少观众视为本季最大的潜力黑马。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20promotional%20scene%20of%20several%20original%20characters%20standing%20together%20in%20a%20city%20at%20dusk%2C%20cinematic%20illustration&width=800&height=450&seq=news-inline-03&orientation=landscape', caption: '本季原创作品预告画面（合成示意图）' },
      { type: 'paragraph', text: '具体的开播时间与平台信息仍有可能调整，最终请以官方公告为准。妖精动漫也会持续跟进，为你带来第一手资讯。' },
    ],
    tags: ['新番', '前瞻', '推荐'],
    category: '新番动态',
  },
  {
    id: 'news-004',
    title: '《深海回响》获年度最佳剧情动画提名',
    date: '2026-10-03',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20moody%20anime%20key%20visual%20of%20a%20submarine%20descending%20into%20a%20glowing%20deep%20sea%20trench%2C%20teal%20tones%2C%20news%20banner%20illustration&width=800&height=450&seq=news-cover-04&orientation=landscape',
    summary: '在今年的年度动画评选提名名单中，《深海回响》跻身最佳剧情动画与最佳音效两项提名。',
    content: [
      { type: 'paragraph', text: '年度动画评选的提名名单于今日公布。《深海回响》凭借其压抑而精致的叙事氛围，成功入围最佳剧情动画、最佳音效两项大奖。' },
      { type: 'heading', text: '用声音讲故事的野心之作' },
      { type: 'paragraph', text: '评委会在点评中提到，该作品对「声音」这一主题的处理尤为出色，深海中若隐若现的低语不仅是剧情线索，也构成了整部作品独特的沉浸体验。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20glowing%20deep%20sea%20creatures%20surrounding%20a%20diver%20in%20a%20dark%20trench%2C%20teal%20bioluminescence%2C%20illustration&width=800&height=450&seq=news-inline-04&orientation=landscape', caption: '剧中的深海场景（官方公开画面）' },
      { type: 'paragraph', text: '最终获奖结果将在下月举行的颁奖典礼上揭晓，妖精动漫将全程跟踪报道。' },
    ],
    tags: ['深海回响', '奖项', '剧情'],
    category: '行业动态',
  },
  {
    id: 'news-005',
    title: '妖精动漫年度盛典：最受欢迎动漫角色评选启动',
    date: '2026-09-30',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Festive%20anime%20banner%20with%20colorful%20silhouettes%20of%20many%20heroes%20and%20confetti%2C%20celebration%20theme%2C%20gold%20and%20orange%20palette%2C%20illustration&width=800&height=450&seq=news-cover-05&orientation=landscape',
    summary: '一年一度的角色人气评选正式开启，快来为你心中的最佳角色投上一票，参与还有机会获得限定周边。',
    content: [
      { type: 'paragraph', text: '妖精动漫年度盛典正式启动，本年度最受欢迎动漫角色评选即日起开放投票。所有入围角色均来自今年播出或完结的人气作品。' },
      { type: 'heading', text: '投票规则一览' },
      { type: 'paragraph', text: '每位用户每天可投出三票，可投给不同的角色。投票将持续两周，最终结果将在页面上公示，并揭晓三大奖项的归属。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Celebratory%20anime%20scene%20of%20a%20stage%20with%20spotlights%20and%20glowing%20character%20portraits%2C%20festive%20gold%20lighting%2C%20illustration&width=800&height=450&seq=news-inline-05&orientation=landscape', caption: '盛典主视觉（活动示意图）' },
      { type: 'paragraph', text: '参与投票的观众还有机会获得限定周边礼包。本次评选与投票数据仅供娱乐参考。' },
    ],
    tags: ['活动', '投票', '角色'],
    category: '站内活动',
  },
  {
    id: 'news-006',
    title: '《长安幻夜》制作组访谈：如何还原盛唐气象',
    date: '2026-09-26',
    author: '特约撰稿人 · 青岚',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20an%20ancient%20Chinese%20city%20at%20night%20with%20thousands%20of%20lanterns%2C%20warm%20golden%20light%2C%20news%20banner%20illustration&width=800&height=450&seq=news-cover-06&orientation=landscape',
    summary: '从建筑细节到服饰纹样，我们与《长安幻夜》的美术团队聊了聊，那些藏在画面里的考据功夫。',
    content: [
      { type: 'paragraph', text: '《长安幻夜》播出后，其精致的美术呈现成为观众讨论的焦点。我们邀请到该项目的美术总监，聊聊那些藏在画面细节中的用心之处。' },
      { type: 'heading', text: '一座城，先要立得住' },
      { type: 'paragraph', text: '美术团队在前期绘制了大量城市布局草图，参考了唐代坊市的结构。为了兼顾奇幻氛围，他们在写实基础上加入了大量灯笼与光影元素，让夜晚的长安既真实又梦幻。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Detailed%20anime%20painting%20of%20ancient%20Chinese%20palace%20architecture%20with%20ornate%20roofs%20and%20lanterns%2C%20warm%20golden%20evening%20light%2C%20illustration&width=800&height=450&seq=news-inline-06&orientation=landscape', caption: '剧中长安城场景（官方公开画面）' },
      { type: 'heading', text: '服饰与纹样的小心思' },
      { type: 'paragraph', text: '角色的服饰纹样会根据身份与场合变化，团队为此整理了详细的设定表。美术总监笑称，有些细节观众未必注意得到，但他们希望每一帧都经得起细看。' },
    ],
    tags: ['长安幻夜', '访谈', '幕后'],
    category: '幕后探访',
  },
  {
    id: 'news-007',
    title: '日本动画产业报告：全球市场规模再创新高',
    date: '2026-09-22',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Business%20infographic%20banner%20with%20anime%20characters%20and%20rising%20charts%2C%20clean%20modern%20illustration%2C%20news%20banner&width=800&height=450&seq=news-cover-07&orientation=landscape',
    summary: '最新发布的行业报告显示，全球动画市场规模连续多年增长，海外收入占比进一步提升。',
    content: [
      { type: 'paragraph', text: '最新发布的动画产业年度报告显示，过去一年全球动画市场规模继续保持增长态势，其中来自海外的收入占比进一步上升。' },
      { type: 'heading', text: '流媒体成为主要增长引擎' },
      { type: 'paragraph', text: '报告指出，流媒体平台的持续投入是行业增长的重要动力。越来越多的作品选择全球同步上线，使得海外观众的观看体验大幅提升。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20illustration%20of%20streaming%20platforms%20and%20global%20map%20connections%2C%20blue%20and%20orange%20palette%2C%20infographic%20style&width=800&height=450&seq=news-inline-07&orientation=landscape', caption: '市场规模趋势示意（报告配图）' },
      { type: 'paragraph', text: '不过报告也提到，行业在人才储备与制作周期方面仍面临挑战，如何在保证质量的同时提升产能，将是未来几年的关键课题。' },
    ],
    tags: ['行业', '报告', '市场'],
    category: '行业动态',
  },
  {
    id: 'news-008',
    title: '《钢铁纪元》剧场版预告片解析：那些值得注意的细节',
    date: '2026-09-18',
    author: '特约撰稿人 · 青岚',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20giant%20mecha%20standing%20against%20a%20burning%20city%20skyline%2C%20orange%20and%20steel%20tones%2C%20news%20banner%20illustration&width=800&height=450&seq=news-cover-08&orientation=landscape',
    summary: '剧场版预告片虽短，信息量却很大。我们逐帧分析了其中的画面，发现了几处耐人寻味的彩蛋。',
    content: [
      { type: 'paragraph', text: '《钢铁纪元》剧场版的首支预告片上线后，立刻引发了粉丝的热议。虽然片长仅一分半，但其中埋藏的细节相当丰富。' },
      { type: 'heading', text: '新机体的短暂亮相' },
      { type: 'paragraph', text: '在预告片的第 47 秒，出现了一台此前从未露面的机甲剪影。结合它的轮廓与配色，不少粉丝推测这可能是主角机体的一次全面升级。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20a%20sleek%20new%20mecha%20silhouette%20backlit%20by%20sunset%2C%20dramatic%20steel%20and%20orange%20tones%2C%20illustration&width=800&height=450&seq=news-inline-08&orientation=landscape', caption: '预告片中一闪而过的新机体（官方公开画面）' },
      { type: 'paragraph', text: '除此之外，预告片尾的台词似乎也暗示了故事将走向更沉重的主题。剧场版预计将于明年春季上映。' },
    ],
    tags: ['钢铁纪元', '剧场版', '解析'],
    category: '新番动态',
  },
  {
    id: 'news-009',
    title: '国漫崛起：国产动画出海的新机遇',
    date: '2026-09-14',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20young%20dragon%20rider%20flying%20over%20ancient%20mountains%2C%20epic%20blue%20and%20gold%20palette%2C%20news%20banner%20illustration&width=800&height=450&seq=news-cover-09&orientation=landscape',
    summary: '越来越多的国产动画走向海外，从题材选择到本地化译制，国漫正在探索属于自己的出海路径。',
    content: [
      { type: 'paragraph', text: '近年来，国产动画在海外市场的存在感明显增强。从玄幻武侠到日常治愈，丰富的题材选择让国漫逐渐积累起稳定的海外受众。' },
      { type: 'heading', text: '题材是天然的优势' },
      { type: 'paragraph', text: '业内人士认为，独特的东方美学与文化题材，是国产动画区别于其他地区作品的天然优势。如何把这种优势转化为可持续的竞争力，是接下来要回答的问题。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20an%20eastern%20fantasy%20landscape%20with%20ancient%20temples%20and%20flying%20cranes%2C%20misty%20blue%20and%20gold%20tones%2C%20illustration&width=800&height=450&seq=news-inline-09&orientation=landscape', caption: '具有东方美学的国漫场景（合成示意图）' },
      { type: 'paragraph', text: '与此同时，本地化译制、平台合作与运营模式也在不断成熟，为国漫出海提供了更稳固的支撑。' },
    ],
    tags: ['国漫', '出海', '行业'],
    category: '行业动态',
  },
  {
    id: 'news-010',
    title: '本周动漫资讯汇总：新作、续作与改编动态',
    date: '2026-09-10',
    author: '妖精动漫编辑部',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20news%20banner%20with%20multiple%20small%20colorful%20scenes%20and%20a%20spotlight%2C%20modern%20clean%20illustration%2C%20news%20header&width=800&height=450&seq=news-cover-10&orientation=landscape',
    summary: '一周资讯一次看全：多部新作公布制作阵容，一部热门漫画宣布动画化，某经典系列则传出重启消息。',
    content: [
      { type: 'paragraph', text: '又到了每周资讯汇总时间。本周有多部作品公布了最新动态，涵盖新作、续作与改编企划，我们为你梳理出最重要的几条。' },
      { type: 'heading', text: '热门漫画宣布动画化' },
      { type: 'paragraph', text: '一部连载多年的高人气漫画正式确认动画化，制作阵容与播出档期将在后续的特别直播中公开，原著粉丝翘首以盼。' },
      { type: 'heading', text: '经典系列传出重启消息' },
      { type: 'paragraph', text: '某经典系列的制作方在社交平台放出一张神秘剪影，被广泛解读为重启信号。虽然官方尚未正面回应，相关讨论已经占据多个社区首页。' },
      { type: 'image', image: 'https://readdy.ai/api/search-image?query=Anime%20scene%20of%20a%20mysterious%20silhouette%20figure%20against%20a%20glowing%20spotlight%2C%20teaser%20atmosphere%2C%20illustration&width=800&height=450&seq=news-inline-10&orientation=landscape', caption: '神秘剪影引发广泛猜测（官方公开画面）' },
      { type: 'paragraph', text: '以上就是本周的资讯汇总，更多内容欢迎持续关注妖精动漫。' },
    ],
    tags: ['汇总', '资讯', '改编'],
    category: '每周汇总',
  },
];